import { withTranslation } from 'react-i18next';
import React from 'react';
import { HelmetProvider, Helmet } from 'react-helmet-async';
import docuwareFavIco from '../../images/favicon.ico';

function Header({ t, i18n }: any) {
  return (
    <HelmetProvider>
      <Helmet>
        <title>{t("My Account")}</title>
        <link rel="shortcut icon" href={docuwareFavIco} sizes="16x16" />
      </Helmet>
    </HelmetProvider>

  )
}

export default withTranslation()(Header);
